module.exports = __webpack_public_path__ + "static/media/icon-status-incomplete.d47a3a6f.svg";